import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ENV_TOKEN } from '../../app-module.token';

@Injectable({ providedIn: 'root' })
export class IpService {
    public constService: any;
    readonly environment = inject(ENV_TOKEN);
    private http: HttpClient = inject(HttpClient);

    constructor() {
        this.constService = this.environment;
    }

    getIpAddress(): Observable<{ ip: string }> {
        return this.http.get<{ ip: string }>(this.constService.ipAddress.URL_API);
    }

    getIPAddressPromise(): Promise<string> {
        return new Promise((resolve) => {
            fetch(this.constService.ipAddress.URL_API)
                .then(respuestaRaw => respuestaRaw.json())
                .then(respuesta => {
                    resolve(respuesta.ip);
                }, error => {
                    console.error(JSON.parse(JSON.stringify(error)));
                    resolve('');
                });
        });
    }
}